// LLM 出力に多い Markdown 表記ゆらぎを吸収する正規化。
// - `** foo **` の内側スペースを除去
// - `**bold**` / `__bold__` を <strong> に変換 (rehype-raw で描画)
//   → CJK 境界問題を回避。内部に単独の `*` や改行を含むケース、
//     `***bold italic***` などの3連続パターンも壊さない。
export function normalizeMarkdown(text: string): string {
  return text
    .replace(/\*\*[ \t]+((?:[^*]|\*(?!\*))+?)[ \t]+\*\*/g, '**$1**')
    .replace(/(?<!\*)\*\*((?:[^*]|\*(?!\*))+?)\*\*(?!\*)/g, '<strong>$1</strong>')
    .replace(/(?<!_)__((?:[^_]|_(?!_))+?)__(?!_)/g, '<strong>$1</strong>');
}
